<template>
    <div class="f-topic-official-more-operation-op">
        <!-- 选择问题状态 -->
        <mini-step class="f-topic-official-more-operation-process"
            :info="OfficialBoardLabel.QuestionCategory">
            <veui-radio-group slot="options"
                v-show="!isClosed && canOperateOfficial"
                class="f-topic-official-more-options"
                v-model="selectedCategory"
                :items="questionCategory"
                :readonly="isAuditPending"
            ></veui-radio-group>
            <span slot="text"
                v-if="(isClosed || !canOperateOfficial)
                    && selectedQuestionCategory > 0">
                {{questionCategory[selectedQuestionCategory - 1].label}}
            </span>
        </mini-step>

        <!-- 选择问题类型，问题状态为'确认问题'出现 -->
        <mini-step v-show="selectedQuestionCategory === 1"
            class="f-topic-official-more-operation-type"
            :info="OfficialBoardLabel.QuestionType">
            <veui-radio-group v-show="!isClosed && canOperateOfficial"
                slot="options"
                class="f-topic-official-more-options"
                v-model="selectedType"
                :items="questionType"
                :readonly="isAuditPending"
            ></veui-radio-group>
            <span slot="text"
                v-if="(isClosed || !canOperateOfficial)
                    && selectedQuestionType > 0">
                {{questionType[selectedQuestionType - 1].label}}
            </span>
        </mini-step>

        <!-- 选择问题方向, 问题状态为'确认问题'出现 -->
        <mini-step :info="OfficialBoardLabel.QuestionTag"
            class="f-topic-official-more-operation-level"
            v-show="selectedQuestionCategory === 1
                && selectedQuestionType > 0">
            <veui-radio-group slot="options"
                v-show="!isClosed && canOperateOfficial"
                class="f-topic-official-more-options"
                v-model="selectedTag"
                :items="questionTag"
                :readonly="isAuditPending"
            ></veui-radio-group>
            <span v-if="(isClosed || !canOperateOfficial)
                && selectedQuestionTag > 0"
                slot="text">
                {{questionTag[selectedQuestionTag - 1].label}}
            </span>
        </mini-step>

        <!-- 提供复现路径, 问题状态为'确认问题'且问题类型为'bug'出现 -->
        <mini-step
            v-show="selectedQuestionCategory === 1
                && selectedQuestionType === 1"
            :info="OfficialBoardLabel.QuestionDetail"
            class="f-topic-official-more-operation-level">
            <span slot="annex"
                v-if="!isAuditPending && !isClosed && canOperateOfficial
                    && (officialinfo.questionDetail.length || hasInputDetail)"
                class="f-topic-official-more-annex"
                @click="resetDetail"
                :tip="clearDeTailTip">
                还原/清空
            </span>
            <editor-component slot="editor"
                v-if="!isAuditPending && !isClosed && canOperateOfficial"
                class="f-topic-official-more-editor"
                :editorid="'questionDetailEditor'"
                @change="hasChangeDetail"
                ref="questionDetail"></editor-component>
            <div slot="text"
                v-if="isAuditPending || isClosed || !canOperateOfficial"
                v-html="officialinfo.questionDetail"
                class="f-topic-official-more-scroll"></div>
        </mini-step>

        <!-- 选择bug级别, 问题状态为'确认问题'且问题类型为'bug'/'需求'出现 -->
        <mini-step class="f-topic-official-more-operation-level"
            v-show="selectedQuestionCategory === 1
                && (selectedQuestionType === 1
                || selectedQuestionType === 2)"
            :info="OfficialBoardLabel.BugLevel">
            <veui-radio-group v-show="!isClosed && canOperateOfficial"
                slot="options"
                class="f-topic-official-more-options"
                v-model="selectedLevel"
                :items="bugLevel"
                :readonly="isAuditPending"
            ></veui-radio-group>
            <span v-if="(isClosed || !canOperateOfficial)
                && selectedBugLevel > -1"
                slot="text">
                {{bugLevel[selectedBugLevel].label}}
            </span>
        </mini-step>

        <!-- 提交变更官方处理状态-->
        <div class="f-topic-official-more-operation-submit"
            v-if="!isClosed && canOperateOfficial">
            <veui-button ui="primary"
                class="f-topic-official-more-btn"
                @click="confirmQuestionCategory"
                :disabled="isAuditPending">
                设置
            </veui-button>
        </div>
    </div>
</template>

<style lang="less">
    @import '../../../../assets/less/views/topic-content/official-process/official-process-board.less';
</style>

<script>
import {mapState, mapGetters} from 'vuex';
import Editor from '@/views/components/tinyEditor';
import MiniStep from './MiniStep.vue';
import {Button, RadioGroup} from 'veui';

import {throttle} from '@/utils/debounceThrottle';
import toast from 'veui/managers/toast';
import {scrollToId} from '@/utils/decorate/scroll';

export default {
    components: {
        'editor-component': Editor,
        'mini-step': MiniStep,
        'veui-radio-group': RadioGroup,
        'veui-button': Button
    },
    computed: {
        ...mapState({
            OfficialBoardLabel: state => state.topicContent.OfficialBoardLabel,
            clearDeTailTip: state => state.topicContent.clearDeTailTip,
            questionCategory: state => state.topicContent.questionCategory,
            questionType: state => state.topicContent.questionType,
            questionTag: state => state.topicContent.questionTag,
            bugLevel: state => state.topicContent.bugLevel,
            selectedQuestionCategory: state => state.topicContent.selectedQuestionCategory,
            selectedQuestionType: state => state.topicContent.selectedQuestionType,
            selectedQuestionTag: state => state.topicContent.selectedQuestionTag,
            selectedBugLevel: state => state.topicContent.selectedBugLevel,
            showTips: state => state.topicContent.showTips,
            officialinfo: state => state.topicContent.topicData.ext.qaOfficialInfo,
            hasInputDetail: state => state.topicContent.hasInputDetail
        }),
        ...mapGetters([
            'followUserName',
            'isClosed',
            'canOperateOfficial',
            'isAuditPending',
            'isBug'
        ]),
        selectedCategory: {
            get() {
                return this.selectedQuestionCategory;
            },
            set(num) {
                this.$store.commit('setSelectedQuestionCategory', num);
            }
        },
        selectedType: {
            get() {
                return this.selectedQuestionType;
            },
            set(num) {
                this.$store.commit('setSelectedQuestionType', num);
            }
        },
        selectedTag: {
            get() {
                return this.selectedQuestionTag;
            },
            set(num) {
                this.$store.commit('setSelectedQuestionTag', num);
            }
        },
        selectedLevel: {
            get() {
                return this.selectedBugLevel;
            },
            set(num) {
                this.$store.commit('setSelectedBugLevel', num);
            }
        }
    },
    mounted() {
        this.initQuestionCategory(this.officialinfo);
    },
    updated() {
        this.setDetailPlaceholder(this.selectedQuestionTag);
    },
    methods: {
        getDetail() {
            const content = this.$refs.questionDetail.getContent();
            return content;
        },
        initQuestionCategory(query) {
            // 初始化问题选中状态
            this.$store.commit('initSelectedQuestionState', query);
            // 渲染复现路径
            this.setDetailPlaceholder(query.questionTag);
        },
        // 确认问题分类
        confirmQuestionCategory: throttle(function () {
            // 没有跟进人员
            if (this.followUserName === '无') {
                toast.info(this.showTips.lackFollowUser);
                scrollToId('official-board');
                return;
            }

            if (!this.selectedQuestionCategory) {
                // 未选中问题归类
                toast.info(this.showTips.missInfoParams);
                scrollToId('official-step-1');
                return;
            }
            let query = {
                questionCategory: this.selectedQuestionCategory
            };
                // 确认问题类型
            if (this.selectedQuestionCategory === 1) {
                if (!this.selectedQuestionType) {
                    // 未选中问题类型
                    toast.info(this.showTips.missInfoParams);
                    scrollToId('official-step-1');
                    return;
                }
                query.questionType = this.selectedQuestionType;

                if (!this.selectedQuestionTag) {
                    // 未选中问题标签
                    toast.info(this.showTips.missInfoParams);
                    scrollToId('official-step-1');
                    return;
                }
                query.questionTag = this.selectedQuestionTag;

                // 问题类型为bug
                if (this.selectedQuestionType === 1) {
                    let pureText = this.$refs.questionDetail.getText();
                    let content = this.$refs.questionDetail.getContent();
                    // 未填复现路径/未选择bug定级，不允许任意一项为空
                    if ((pureText.length === 0 && content.indexOf('img') === -1)
                            || this.selectedBugLevel === -1) {
                        toast.info(this.showTips.missInfoParams);
                        scrollToId('official-step-1');
                        return;
                    }

                    query.questionLevel = this.selectedBugLevel;
                    query.questionDetail = content;
                }
                else if (this.selectedQuestionType === 2) {
                    if (this.selectedBugLevel === -1) {
                        toast.info(this.showTips.missInfoParams);
                        scrollToId('official-step-1');
                        return;
                    }
                    query.questionLevel = this.selectedBugLevel;
                    query.questionDetail = '';
                }
                else {
                    query.questionLevel = -1;
                    query.questionDetail = '';
                    // 如果原来状态是确认问题下的bug/需求，现变更为not a bug
                    if (this.officialinfo.questionCategory === 1
                            && this.officialinfo.questionType !== 3) {
                        this.$emit('clear', query);
                        return;
                    }
                }
            }
            else {
                query.questionType = 0;
                query.questionLevel = -1;
                query.questionDetail = '';
                query.questionTag = 0;

                // 如果原来状态是确认问题下的bug/需求，现变更为未复现/信息缺失
                if (this.officialinfo.questionCategory === 1
                        && this.officialinfo.questionType !== 3) {
                    this.$emit('clear', query);
                    return;
                }
            }
            this.$store.dispatch('confirmQuestionCategory', {query})
                .then(() => {
                    this.$emit('after', query);
                    this.$store.commit('setHasInputDetail', false);
                });
        }),
        setDetailPlaceholder(questionTag) {
            // bug下才有复现路径
            // 如果已经有内容输入不再变动内容
            if (this.isBug && !this.hasInputDetail && this.$refs.questionDetail) {
                let content = '';
                // 有复现路径内容时填入内容
                if (this.officialinfo.questionDetail.length) {
                    content = this.officialinfo.questionDetail;
                }
                // 没有复现路径内容时
                // 如果有填充内容，则填入
                else if (this.OfficialBoardLabel.QuestionDetail.text[questionTag]) {
                    content = this.OfficialBoardLabel.QuestionDetail.text[questionTag];
                }
                this.$refs.questionDetail.setContent(content);
            }
        },
        hasChangeDetail() {
            if (!this.hasInputDetail) {
                this.$store.commit('setHasInputDetail', true);
            }
        },
        resetDetail() {
            // 如果有填充内容，则填入
            if (this.OfficialBoardLabel.QuestionDetail.text[this.selectedQuestionTag]) {
                const ctx = this.OfficialBoardLabel.QuestionDetail.text[this.selectedQuestionTag];
                this.$refs.questionDetail.setContent(ctx);
            }
            // 如果没有填充内容，则置空
            else {
                this.$refs.questionDetail.setContent('');
            }
            this.$store.commit('setHasInputDetail', false);
        }
    }
};
</script>

